import { Heart, Mail, Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-primary to-[#1e4d37] text-white">
      <div className="container max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8">
          {/* Logo & Description */}
          <div className="space-y-4">
            <img
              src="/OriginalLogoSymbol.png"
              alt="Nutri Results with Aleks"
              className="h-16 w-auto"
            />
            <p className="text-sm text-gray-200 leading-relaxed">
              Personalised nutrition and lifestyle support to help you achieve
              your health goals.
            </p>
            <div className="flex items-center gap-2 text-sm">
              <Heart className="w-4 h-4 text-green-300" />
              <span className="text-gray-200">
                Evidence-informed nutrition therapy
              </span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col lg:justify-center sm:justify-start lg:items-center">
            <h3 className="text-lg  font-bold mb-4">Quick Links</h3>
            <ul className="space-y-3 flex flex-col justify-center text=-center">
              <li>
                <button
                  onClick={() => navigate("/about")}
                  className="text-sm text-left flex justify-start text-gray-200 hover:text-green-300 transition-colors duration-200"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/approach")}
                  className="text-sm text-left flex justify-start text-gray-200 hover:text-green-300 transition-colors duration-200"
                >
                  Approach
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/consultations")}
                  className="text-sm text-left flex justify-start text-gray-200 hover:text-green-300 transition-colors duration-200"
                >
                  Consultations
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/nutrition-therapy")}
                  className="text-sm text-left flex justify-start text-gray-200 hover:text-green-300 transition-colors duration-200"
                >
                  Nutrition Therapy
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/contact")}
                  className="text-sm text-left flex justify-start text-gray-200 hover:text-green-300 transition-colors duration-200"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 flex justify-start">
              Get in Touch
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-green-300 flex-shrink-0" />
                <a
                  href="mailto:aleksandra@nrwa.co.uk"
                  className="text-sm text-gray-200 hover:text-green-300 transition-colors duration-200"
                >
                  aleksandra@nrwa.co.uk
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-green-300 flex-shrink-0" />
                <a
                  href="tel:07814618877"
                  className="text-sm text-gray-200 hover:text-green-300 transition-colors duration-200"
                >
                  07814618877
                </a>
              </li>
            </ul>
            <div className="mt-6">
              <p className="text-sm flex items-center text-gray-200 mb-2">
                Based in Ealing, West London
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-300">
              © {currentYear} NutriResults with Aleks. All rights reserved.
            </p>
            <div className="flex space-x-2">
              <img src="/bant.jpg" alt="BANT Logo" className="h-8" />
              <img src="/cnhn.jpg" alt="CNHC Logo" className="h-12 ml-4" />
            </div>
            <div className="flex items-center gap-6">
              {/* <button
                onClick={() => navigate("/terms")}
                className="text-sm text-gray-300 hover:text-green-300 transition-colors duration-200"
              >
                Terms & Conditions
              </button> */}
              <button
                onClick={() =>
                  window.open("/GDPR_PrivacyNotice_NTBusiness.pdf", "_blank")
                }
                className="text-sm text-gray-300 hover:text-green-300 transition-colors duration-200"
              >
                Privacy Policy
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
